import React, { useEffect, useMemo, useState } from 'react';

import { Link, Navigate, useParams } from 'react-router-dom';

import Layout from '../../components/Layout/Layout';

import SeoHead from '../../components/Seo/SeoHead';

import seoService from '../../services/seoService';

import { getFeatureBySlug } from '../../content/features/catalog';

import { getFeatureArticle } from './articles';

import FeatureComments from './FeatureComments';

import styles from './Features.module.css';



const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://comics-earth.fr';



const FeatureDetail = () => {

  const { slug } = useParams();

  const feature = getFeatureBySlug(slug);

  const Article = getFeatureArticle(slug);

  const [seo, setSeo] = useState(null);



  const fallbackSeo = useMemo(() => {

    if (!feature) {

      return null;

    }



    return {

      metaTitle: `${feature.title} | Earth Forum`,

      metaDescription: feature.summary,

      canonical: `${FRONTEND_URL}/fonctionnalites/${feature.slug}`,

      ogImage: `${FRONTEND_URL}/images/logo.webp`,

      robotsIndex: true,

    };

  }, [feature]);



  useEffect(() => {

    if (!slug) {

      return undefined;

    }



    let mounted = true;

    seoService.getFeature(slug)

      .then((data) => {

        if (mounted) {

          setSeo(data);

        }

      })

      .catch(() => {

        if (mounted) {

          setSeo(null);

        }

      });



    return () => {

      mounted = false;

    };

  }, [slug]);



  if (!feature || !Article) {

    return <Navigate to="/fonctionnalites" replace />;

  }



  return (

    <Layout wide>

      <SeoHead seo={seo || fallbackSeo} />

      <div className={styles.articlePage}>

        <Link to="/fonctionnalites" className={styles.articleBack}>

          ← Retour aux fonctionnalités

        </Link>



        <header className={styles.articleHeader}>

          <p className={styles.cardCategory}>{feature.category}</p>

          <h1 className={styles.articleTitle}>{feature.title}</h1>

          <p className={styles.articleIntro}>{feature.summary}</p>

        </header>



        <Article />



        <FeatureComments featureSlug={slug} />

      </div>

    </Layout>

  );

};



export default FeatureDetail;

